import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/store";

export const Testimonials = () => {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0A0908]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 text-center"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#A66E38] mb-3">
            Reseñas
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold tracking-tight text-[#F5F0E6]">
            Lo Que Dicen Nuestros Vaqueros
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#1F1A17] border border-white/5 p-8 md:p-10 hover:border-[#A66E38]/40 transition-colors duration-500"
            >
              <Quote
                className="absolute top-6 right-6 text-[#A66E38]/25"
                size={48}
              />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star
                    key={s}
                    size={18}
                    className="fill-[#C89B3C] text-[#C89B3C]"
                  />
                ))}
              </div>
              <blockquote className="font-serif text-lg md:text-xl italic text-[#F5F0E6] leading-relaxed mb-6">
                “{t.quote}”
              </blockquote>
              <figcaption>
                <p className="text-[#D4B996] font-semibold">{t.name}</p>
                <p className="text-sm text-[#8A7D71] uppercase tracking-wider">
                  {t.role}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
